"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("./utils");
var _toasterService = _interopRequireDefault(require("./utils/toasterService"));
var _Toaster = _interopRequireDefault(require("./styles/Toaster"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Toaster = /*#__PURE__*/function (_React$Component) {
  function Toaster(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Toaster);
    _this = _callSuper(this, Toaster, [props]);
    _this.state = {
      stack: Array(0)
    };
    _toasterService["default"].register(_this);
    return _this;
  }
  (0, _inherits2["default"])(Toaster, _React$Component);
  return (0, _createClass2["default"])(Toaster, [{
    key: "removeColdToast",
    value: function removeColdToast() {
      return this.state.stack.filter(function (x) {
        return x.time > Date.now() - 3000;
      });
    }
  }, {
    key: "removeToast",
    value: function removeToast(time) {
      var warmToast = this.removeColdToast();
      var remainingToast = warmToast.filter(function (x) {
        return x.time !== time;
      });
      this.setState({
        stack: remainingToast
      });
    }
  }, {
    key: "eatToast",
    value: function eatToast() {
      var _this2 = this;
      (0, _utils.debounce)(function () {
        return _this2.removeToast();
      }, (0, _utils.getTimeoutSeconds)(3));
    }
  }, {
    key: "popToast",
    value: function popToast(toast) {
      this.setState({
        stack: [].concat((0, _toConsumableArray2["default"])(this.state.stack), [toast])
      });
      this.eatToast();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var list = this.state.stack || Array(0);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('toaster', _Toaster["default"].toaster)
      }, list.map(function (item) {
        var removeToast = function removeToast() {
          return _this3.removeToast(item.time);
        };
        var type = item.type.toLowerCase();
        var typeClass = "toast--".concat(type);
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: item.time,
          role: "button",
          tabIndex: 0,
          className: (0, _classnames["default"])('toast', typeClass, _Toaster["default"].toast, _Toaster["default"][typeClass]),
          onClick: removeToast,
          onKeyDown: removeToast
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: (0, _classnames["default"])('toast__title', _Toaster["default"].toast__title)
        }, item.title), /*#__PURE__*/_react["default"].createElement("span", {
          className: (0, _classnames["default"])('toast__message')
        }, item.message));
      }));
    }
  }]);
}(_react["default"].Component);
Toaster.displayName = 'Toaster';
var _default = exports["default"] = Toaster;